import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
	Button,
	Icon,
	Image,
	Container,
	Loader,
	Modal, 
	Accordion,
	Dropdown,
	CardMeta, 
	Message
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import user_model from "models/user_model";
import UserReferral from "views/UIelems/UserReferral";
import org_model from "models/org_model";
import { useExperiment, useUser } from "xAppLib/Hooks";
import gtm from "../../xAppLib/providers/gtm";
import { cls } from 'views/NUI/utils';
import cat_model from 'models/cat_model'
import moment from "moment";
import SIcon from "../NUI/StreamlineIcons/SIcon";

const user_links = _ => {
	return [
	{
		labelDesk:'Continue your game?',
		label:'Game History & Continue',
		link:'/history',
		desc:'Your game history is securely stored to make continuing your progress easy.',
		icon: <SIcon name="pills-single" cls="text-is-blue h-[56px] w-[56px]" bold/>
	},
	{
		labelDesk:'Daily Challenge',
		label:'Play Daily Challenge',
		link:'/cat',
		desc:<><ul><li>New puzzle every day</li><li>Compete on daily leaderboards</li></ul></>,
		icon:<SIcon name="doc-stamp" size="lg"/>,
		learnmore:'https://www.wewordle.com/daily-challenge'
	},
	{
		labelDesk:'Achievements',
		label:'View Achievements',
		link:'/c/pharm/certs/',
		desc:<><ul><li>Track your progress</li><li>Unlock badges and rewards</li></ul></>,
		icon:<SIcon name="med-cert" size="lg"/>,
		learnmore:'https://www.wewordle.com/achievements'
	},
	{
		labelDesk:'Multiplayer Battle',
		label:'Start Multiplayer Game',
		link:'/cat/DocCons',
		desc:<><ul><li>Challenge friends in real-time</li><li>Fast-paced word battles</li></ul></>,
		icon:<SIcon name="smartphone-cross-hand" size="lg"/>,
		learnmore:'https://www.wewordle.com/multiplayer'
	},
	{
		labelDesk:'Tournament Mode',
		label:'Join Tournament',
		link:'/c/pharm/subscr',
		desc:<><ul><li>Weekly competitive tournaments</li><li>Win prizes and climb rankings</li></ul></>,
		icon:<SIcon name="doc-sign-pen" size="lg"/>,
		learnmore:'https://www.wewordle.com/treatment-plans'
	},
	{
		labelDesk:'Practice Mode',
		label:'Practice Puzzles',
		link:'/c/pharm/patho',
		desc:<><ul><li>Improve your word skills</li><li>No pressure, just fun</li></ul></>,
		icon:<SIcon name="patho-microscope" size="lg"/>,
		learnmore:'https://www.wewordle.com/online-pathology-requests'
	},
	{
		labelDesk:'Leaderboards',
		label:'View Leaderboards',
		link:'/c/pharm/express-specialist-referrals',
		desc:<><ul><li>See top players worldwide</li><li>Track your ranking</li></ul></>,
		icon:<SIcon name="doc-steth" size="lg"/>,
		learnmore:'https://www.wewordle.com/online-specialist-referrals'
	},
]}

const non_user_links = _ => [...user_links()] // Or make these different in future

const Review = ({wide}) => {
	return <div className={cls(wide ? 'wide':'compact', 'review-actions')}>
		<div className={cls(!wide && "order-last")}>
			{/*<a onClick={(e) => { e.preventDefault(); gtm.log('', 'outbound', {link: e.currentTarget.href}); window.open(e.currentTarget.href, '_blank').focus(); }} href='https://www.productreview.com.au/listings/wewordle' target='_blank'>*/}
				<img src="https://api.productreview.com.au/api/services/rating-badge/v2/au/e7b8b688-a5ac-4c9c-9607-d21714b7c6f9/from-internal-entry-id?resolution=hd&amp;theme=light&amp;width=160&amp;hideLabel=true" alt="WeWordle" width="200" />
			{/*</a>*/}
		</div>
		<div>
			<h2 className={cls(!wide && 'lg:w-2/3 xl:w-3/4')}>Discover why thousands of Australians use WeWordle</h2>
			<p className={cls(!wide && 'w-1/2')}>People from all over Australia are loving our service.</p>
			{/*<a onClick={(e) => { e.preventDefault(); gtm.log('', 'outbound', {link: e.target.href}); window.open(e.target.href, '_blank').focus(); }} href='https://www.productreview.com.au/listings/wewordle' target='_blank' className='ui button'>Leave a review</a>*/}
		</div>
		
		
	</div>
}

const QuizHomeBanner = () => {
    return <Container className="quiz-home-banner flex items-center justify-center mx-auto z-10 w-full" style={{maxWidth: '1292px'}}>
                <div className='bg-is-blue-20 rounded-lg shadow-none lg:shadow-lg flex flex-wrap md:flex-nowrap justify-center md:justify-between items-center w-full text-is-black p-6 lg:p-4'>
                    <span className="flex flex-wrap xl:flex-nowrap items-center text-center md:text-left mb-4 md:mb-0 md:mr-2 lg:mr-0">
                        <h4 className="w-full md:w-auto" style={{fontSize: '1.5rem'}}>Not sure where to start? <span style={{fontWeight: '300'}}>Find the right treatment for you</span></h4>
                    </span>
                    <Button as={Link} to="/navig" className="mt-4 lg:my-0 lg:ml-4 max-w-[306px]" color="blue" size="small">Product Navigator</Button>
                </div>
            </Container>
}
 
const CTA = ({user_in}) => {
	
	const show_hist = user_in && app.user.prof?.pts_scrs > 0

	const histEl = user_links()[0]
	const tile_links = user_in ? user_links() : non_user_links();

	return (
		<div
			id="home-section-features"
			className={
				"py-6 sm:py-8 home-section home-section-features " +
				(user_in ? "user" : "nonuser")
			}
		>
			<div className="section-container ui container">

				<div className="section-header ui center aligned header-wrap mb-4 text-center">
					<h2 className="section-title">Play and compete with friends online</h2>
					<p className="font-bold">Challenge players worldwide. Available 24/7 every day</p>
				</div>
			
				<div className={['flex flex-wrap justify-center feature-entries user-cta md:-mx-2 md:mb-2', show_hist && 'hist'].filter(Boolean).join(' ')}>
					{tile_links.filter(el=>el.link!='/history').map((el,i)=> 
					<div key={i} className={["relative intro-tiles bg-is-blue mb-4 p-0 md:p-4 rounded-md text-white", el.link.split('/').pop(),el.cls].filter(Boolean).join(' ')}>
						<Link to={el.link} className="flex flex-row md:flex-col items-center md:items-start hover:text-white w-full" data-testid="link-tile">
							<div className="entry-image-box relative md:absolute">
								{el.icon}
							</div>
							<div className="flex flex-col w-full relative md:mt-[72px] mb-4 md:mb-0">
								<h4 className="md:order-2">{el.labelDesk}</h4>
							</div>
							<div className="entry-content md:mb-4 text-is-white">
								{el.desc}
								<SIcon name="chevron" size="xs" cls="md:hidden -rotate-90 mr-4" bold/>
							</div>
							<Button color="blue" fluid basic>{el.label}</Button>
						</Link>

						{el.learnmore && <a href={el.learnmore} onClick={ e => { e.preventDefault(); e.stopPropagation(); window.open(el.learnmore, '_blank').focus() } }
						style={{textDecoration:'underline'}} className="absolute bottom-2 md:bottom-0 md:right-4 md:top-2 left-[90px] md:left-auto h-[24px] text-white cursor-pointer text-lg font-semibold hover:text-white !decoration-is-blue hover:!decoration-white underline-offset-2">
						<div className='flex items-center text-base'><SIcon name="external" color="white" bold cls="h-[20px] w-[20px] md:h-[24px] md:w-[24px] order-2 md:order-none ml-1 md:ml-0"/>Learn more</div></a>}
					
					</div>
					)}
					
				</div>

				{show_hist && (<div className="ui row w-full mx-auto">
						<Link
							// key={i}
							a="a"
							to={histEl.link}
							className="history-feature w-full flex flex-col md:flex-row relative p-4 bg-is-blue-20 text-is-black rounded-md mb-4 md:mb-0"
						>
							{histEl.icon}
							<div className="md:ml-6 mb-2 md:mb-0">
								<h4 className="font-bold absolute md:relative top-4 md:top-0 left-20 md:left-0 w-1/2 md:w-full" style={{marginBottom:0}}>{histEl.labelDesk}</h4>
								<p className="mt-4 md:mt-0">{histEl.desc}</p>
							</div>

							<div className="flex items-center md:justify-end grow">
								<span className="ui button primary">
									Continue Playing
								</span>
							</div>
						</Link>
					</div>)}

				<div className="extra-actions md:hidden">
					{/*<Modal
						trigger={
								<Button className="refer">
									Refer a friend
								</Button>
						}
						basic
						closeIcon
						on="click"
						wide="very"
					>
						<Modal.Content>
							<UserReferral fancy />
						</Modal.Content>
					</Modal>*/}
					<Button
						inverted
						color="blue"
						className="contact"
						fluid
						onClick={(_) => {
							app.trigger(app.events.SHOW_POPUP, {
								tp: "pu",
								pt: "contact",
								txt: "Contact Us",
								u: "contact-us",
								pn: "contact-us",
								target: "iscr",
							});
						}}
					>
						Contact Us
					</Button>
				</div>

			</div>
		</div>
	);

};

const Hero = ({user_in, about}) => {

    const returnDoctorInfo = () => {
        return <>
        <strong>Top Player</strong>
        <p className="text-xs">WeWordle Champion</p>
        </>
    }

	const days_old = moment().diff(moment(app.user?.prof?.cre_tm),'days')
	const newUser = days_old < 3

	const user_header = user_in && !app.state.in_sgup_st2;

    return <div id="home-section-hero" className="home-section home-section-hero">
                <div className={cls("section-user h-full relative hero-container bg-cover", user_header ? "user bg-is-gray" : "bg-is-blue-100 no-user flex flex-col flex-col-reverse md:block h-full")}>
					
					<div className={`hero-img bg-no-repeat sm:h-full w-full relative sm:absolute
						${user_header ? 'h-[345px] bg-cover sm:bg-contain lg:bg-cover xl:bg-[length:auto_100%] bg-hero-user-sm md:bg-hero-user-md lg:bg-hero-user-lg bg-top sm:bg-right' : 'h-[220px] bg-contain sm:bg-cover bg-hero-sm sm:bg-hero-lg bg-right-bottom sm:bg-[70%] xl:bg-right'}`}>
						{user_header && <div className="return-doctor-info flex-col items-end absolute text-gray-600 text-sm">{returnDoctorInfo()}</div>}
					</div>

                    <Container className="h-full">
                        <div className="h-full grid sm:grid-cols-10 home-section hero-container mb-4 md:mb-0">
                            <div className="sm:col-span-5 md:col-span-5 lg:col-span-5 xl:col-span-6 2xl:col-span-8 sm:z-10 text-center sm:text-left mt-4 sm:mt-0">
                                {user_header && <div className="p-6 sm:pt-20 sm:pb-32">
                                    <p className="section-title text-is-blue">Welcome{newUser ? "!": " back!"}<br/>How can we help you today?</p>
                                    <p className="section-subtitle text-gray-600">{app.acl.has_history && <>Your game history is stored securely to make<br className='lg' /> tracking your progress easy.</> || <>Daily challenges, multiplayer battles,<br className='lg' /> leaderboards, and word puzzles</>}</p>
                                    {app.acl.has_history && <Link to="/history">
                                        <div>
                                            <span className="ui button primary"><strong>Continue Playing</strong></span>
                                        </div>
                                    </Link>}
                                    </div> ||
                                    <div className="hero-wrap sm:py-8 md:py-20 lg:py-32"><h1 className="text-white no-user text-left w-full">Join thousands of players worldwide<br className='title' /> in multiplayer word battles </h1>
                                        <h2 className="section-subtitle no-user text-left">Fun and competitive word gaming:<br/>
                                        Daily challenges, multiplayer battles,<br className='lg' /> leaderboards, and word puzzles
                                        </h2>
										{/* <Button as={Link} to="/cat">Medicines Catalogue</Button> */}
                            		</div>}
									<span className="home-anchor" id="try-wewordle-now"></span>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
};

const HIW = () => {

	const tile_data = [
		{
			num: 1,
			desc: 'Choose your game mode',
			icons: ['monitor-cross', 'smartphone-cross-hand']
		},
		{
			num: 2,
			desc: 'Select single player or multiplayer',
			icons: ['steth-heart', 'medical-check-cross']
		},
		{
			num: 3,
			desc: 'Solve word puzzles and compete',
			icons: ['pill-bottle', 'chart-pills']
		},
		{
			num: 4,
			desc: 'Earn points and climb the leaderboards',
			icons: ['retail-counter', 'delivery-pill']
		},
	]
	return <div id="home-section-hiw" className="home-section home-section-hiw pt-6 pb-0 sm:py-8 bg-is-gray">
		<div className="section-container ui container">
			<div className="pb-8"><h2 className="section-title">How WeWordle works</h2></div>
		  <div className="section-content ui grid">
		    <div className="tiles ui row">
		  	{tile_data.map((el, i) =>
			  <div className="content-col column sixteen wide mobile eight wide tablet four wide computer" key={i}>
			    <h2 className="section-title bg-white center">{el.num}</h2>
			    <div className="inner flex flex-col items-center justify-between mx-auto mb-10 sm:mb-0">
			      <p>{el.desc}</p>
				  <div className="flex items-center justify-center text-is-blue">
					<SIcon name={el.icons[0]} size="lg"/>
					<SIcon name={el.icons[1]} size="lg"/>
				  </div>
			    </div>
			  </div>
			)}
		  </div>
		</div>
	  </div>
  	</div>
}


const ScriptTiles = () => {

	const script_tiles = [
		{
			title: 'Classic Mode',
			desc: 'The original word puzzle experience - guess the 5-letter word in 6 tries or less.',
			btn: 'Play Now',
			btnlink: '/c/game/classic',
			learnmore: 'https://www.wewordle.com/classic-mode/'
		},
		{
			title: 'Timed Challenge',
			desc: 'Race against the clock and solve as many puzzles as you can before time runs out.',
			btn: 'Start Challenge',
			btnlink: '/c/game/timed',
			learnmore: 'https://www.wewordle.com/timed-challenge/'
		},
		{
			title: 'Multiplayer',
			desc: 'Challenge friends or random opponents in real-time word battles.',
			btn: 'Find Match',
			btnlink: '/c/game/multiplayer',
			learnmore: 'https://www.wewordle.com/multiplayer/'
		},
		{
			title: 'Daily Puzzle',
			desc: 'A new puzzle every day - compare your score with friends and the world.',
			btn: 'Play Daily',
			btnlink: '/c/game/daily',
			learnmore: 'https://www.wewordle.com/daily-puzzle/'
		},

	]

	const [catList, setCatList] = useState();

	const has_org = !!app.runtime.org;
	useEffect( async _ => {
		if (!has_org) return;

		const {cat_tree_list} = await cat_model.get_cat_list('pharm');
		if(cat_tree_list) {
			let data = {};
			Object.entries(cat_tree_list).forEach(([key, v]) => {
				if(cat_tree_list[key].active == true) {
					data = {...data, [key]: {
					key: key,
					text: v.n.charAt(0).toUpperCase() + v.n.toLowerCase().slice(1),
					as: Link,
					to: `/cat/${key}`
					}}
				}
			});
			setCatList(Object.values(data));
		}
	}, [has_org]);

	return <div className="home-section script-tiles bg-is-gray pt-4 sm:pt-8">
		<div className="section-container ui container">
		  <div className="section-content ui grid">
		    <div className="ui row mb-4">
			  <div className="section-header ui center aligned header-wrap text-center mx-auto">
			  	<h2 className="section-title">Quick game modes</h2>
				<p className="font-bold">WeWordle offers multiple exciting game modes for word puzzle enthusiasts.<br/>
					Explore and learn more about the game types below.</p>
		      </div>
		  </div>
		  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
		  	{script_tiles.map((el, i) =>
			  <div className="col-span-1 rounded-md shadow bg-white mx-1 p-8 mb-4 flex flex-col" key={i}>
					<h4 className="bg-white center">{el.title}</h4>
					<p>{el.desc}</p>
					<div className="mt-auto text-center">
						<Button className="mt-auto" color="blue" as={Link} to={el.btnlink}>{el.btn}</Button><br/>
						<a className="more-link text-is-blue" href={el.learnmore} target="_blank">Learn more</a>
					</div>
			</div>
			)}
		  </div>
		  {catList?.length > 0
			  ? <Dropdown trigger="Explore more categories" options={catList} />
			  : <div className="my-8"></div>
		  }
		</div>
	  </div>
  	</div>
}

const FeaturesTiles = () => {

	const features_tiles = [
		{
			title: 'Play Anywhere',
			desc: 'Available on mobile, tablet, and desktop',
			icon: <SIcon name="steth" clr="#0065F2" size="lg"/>
		},
		{
			title: 'Global Players',
			desc: 'Compete with players from around the world',
			icon: <SIcon name="location-circle" clr="#0065F2" size="lg"/>
		},
		{
			title: 'Multiple Game Modes',
			desc: 'Daily challenges, multiplayer, and tournaments',
			icon: <SIcon name="pill-bottle" clr="#0065F2" size="lg"/>
		},
		{
			title: 'Secure',
			desc: 'Your data is held in our encrypted cloud storage database',
			icon: <SIcon name="shield-tick" clr="#0065F2" size="lg"/>
		},

	]
	return <div className="home-section feature-tiles bg-is-gray pt-6 pb-8 sm:pt-8 sm:pb-14">
		<div className="section-container ui container">
			<div className="section-header ui center aligned header-wrap text-center mx-auto pb-4">
				<h2 className="section-title">Secure and fun gaming experience</h2>
			</div>
		  <div className="section-content ui grid">
		  <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4">
		  	{features_tiles.map((el, i) =>
			    <div key={i} className="col-span-1 rounded-md shadow bg-white p-6 my-2">
					<span className="text-is-blue">{el.icon}</span>
					<h5 className="center">{el.title}</h5>
					<div className="inner flex flex-col items-center justify-between">
					<p>{el.desc}</p>
					</div>
				</div>
			)}
			</div>
		  </div>
	  </div>
  	</div>
}

const ImageTextBanner = () => {
	return <div className="home-section image-text-banner bg-transparent sm:bg-is-gray py-6 sm:py-8 bg-no-repeat bg-[top_0] sm:bg-[35%_40%] md:bg-center xl:bg-[50%_30%] bg-[length:auto_280px] sm:bg-cover" style={{backgroundImage: 'url(images/homepage/woman-on-phone-banner.png)'}}>
		<div className="section-container ui container">
		  <div className="grid sm:grid-cols-2 sm:gap-4">
		  <div className="col-span-1"></div>
		  <div className="col-span-1 mt-[280px] sm:mt-0">
		  	<div className="section-header ui center aligned header-wrap mx-auto" style={{padding:0}}>
				<h2 className="section-title text-center sm:text-left">Ready for a challenge?<br/>Start a multiplayer battle</h2>
			</div>
			<div className="p-2 text-left mb-4">
				<p>Challenge friends and players worldwide in real-time word battles with WeWordle from anywhere.</p>
				<ul className="pl-4 list-disc">
					<li>Real-time multiplayer matches</li>
					<li>Instant matchmaking</li>
					<li>Play anytime, anywhere</li>
					<li>High player satisfaction</li>
				</ul>
			</div>
			<Button className="mt-auto md:max-w-fit" color="blue" fluid as={Link} to="/cat/DocCons">Start Multiplayer Battle</Button>
		  </div>
		</div>
	  </div>
  	</div>

}

const Partners = () => {
	const partners = [
		{
			name: 'Game Partner 1',
			img: 'Health_Engine_logo',
			link: '#'
		},
		{
			name: 'Game Partner 2',
			img: 'Health_Direct_logo',
			link: '#'
		},
		{
			name: 'Game Partner 3',
			img: 'Doctors_logo',
			link: '#'
		},
		{
			name: 'Game Partner 4',
			img: 'Chemist2U_logo',
			link: '#'
		},
		{
			name: 'Game Partner 5',
			img: 'my_mirror',
			link: '#'
		},
	]
	return <div className="home-section partners ui container py-6 sm:py-8">
		  <h2 className="section-title text-center">Our partners</h2>
		  <div className="ui flex flex-row flex-wrap justify-center">
		  	{partners.map((el, i) =>
			  <div className="flex flex-col w-full sm:w-1/2 md:w-1/3 lg:w-1/5" key={el.name}>
				<a className="m-auto w-1/2 sm:w-3/4 cursor-pointer" target="_blank" href={el.link}><img alt={el.name} src={`/images/homepage/${el.img}.png`}/></a>
			</div>
			)}
		  </div>
	  </div>
}

const FAQ = () => {
	const faq = [
		{
			key: 1,
			title: 'What is WeWordle?',
			content: {
				content: (<>
					<p>WeWordle is an exciting multiplayer word puzzle game that lets you challenge friends and players worldwide in real-time word battles.</p>
					<p>Daily challenges, multiplayer battles, leaderboards, and achievements are just some of the features offered by WeWordle.</p>
					<p>Our game is available 24/7 and we take great care in providing the best gaming experience for all players.</p>
					<p>We are proud to bring word puzzle fun to players around the world.</p>
				</>)}
		},
		{
			key: 2,
			title: 'How much does it cost?',
			content: {
				content: (<>
					<p>WeWordle is free to play with optional premium features.</p>
					<p>Daily challenges and basic multiplayer modes are completely free.</p>
					<p>Premium features and tournament modes are available for players who want additional challenges.</p>
				</>)}
		},
		{
			key: 3,
			title: 'Who can play WeWordle?',
			content: {
				content: (<>
				<p>Anyone can play WeWordle! Just create a free account to get started.</p>
				<p>All players can access daily challenges and multiplayer battles.</p>
				<p>Some competitive tournaments may have age or skill requirements.</p>
				</>)}
		},
		{
			key: 4,
			title: 'How do I start playing?',
			content: {
				content: (<>
				<p>Simply create an account and start playing! Choose from daily challenges, quick matches, or multiplayer battles.</p>
				<p>Your progress and achievements are saved automatically to your account.</p>
				<p>You can play on any device - mobile, tablet, or desktop.</p>
				</>)}
		},
		{
			key: 5,
			title: 'How does multiplayer work?',
			content: {
				content: (<>
					<p>Challenge friends directly or get matched with players of similar skill level.</p>
					<p>Real-time word battles let you compete head-to-head to solve puzzles fastest.</p>
					</>)}
		},
		{
			key: 6,
			title: 'What game modes are available?',
			content: {
				content: (<>
				<p>Choose from Daily Challenge, Quick Match, Multiplayer Battle, Tournament Mode, and Practice Mode.</p>
				<p>Each mode offers unique gameplay and rewards.</p>
				<p>New game modes and features are added regularly.</p>
				</>)}
		},
		{
			key: 7,
			title: 'How do leaderboards work?',
			content: {
				content: (<>
				<p>Compete for top spots on daily, weekly, and all-time leaderboards.</p>
				<p>Rankings are based on your performance in various game modes.</p>
				<p>Climb the ranks and earn special badges and achievements.</p>
				</>)}
		},
		{
			key: 8,
			title: 'Can I play with friends?',
			content: {
				content: (<>
				<p>Yes! Invite friends to play directly or join the same tournaments.</p>
				<p>Create private games for friend groups or compete in public matches.</p>
				<p>Share your achievements and challenge friends to beat your scores.</p>
				</>)}
		},
		{
			key: 9,
			title: 'How are achievements earned?',
			content: {
				content: (<>
					<p>Complete challenges, win matches, and reach milestones to unlock achievements.</p>
					<p>Achievements range from beginner badges to expert-level accomplishments.</p>
				</>)}
		},
		{
			key: 10,
			title: 'Is my progress saved?',
			content: {
				content: (<>
					<p>Yes, all your progress, stats, and achievements are saved to your account.</p>
					<p>Play on any device and your progress syncs automatically.</p>
					</>)}
		},
		{
			key: 11,
			title: 'How do I report issues or get help?',
			content: {
				content: (<>
				<p>Contact our support team through the Help section in the app or website.</p>
				<p>Player data is stored securely and encrypted. Your privacy is our priority.</p>
				</>)}
		}
	]

	return <div className="home-section py-6 sm:py-8 faq ui bg-is-gray">
		<h2 className="section-title text-center">Frequently asked questions</h2>
		<Container>
			<Accordion styled panels={faq}/>
		</Container>
		<div className="text-is-blue w-full mt-4 sm:my-4 text-center"><a className="more-link" href="https://www.wewordle.com/faq" >Read more</a></div>
	</div>
}

/*const News = () => {
	const news = [
		{ name: 'Article 1', },
		{ name: 'Article 2', },
		{ name: 'Article 3', },
	]
	return <div className="home-section ui container py-6 sm:py-8">
		  <h2 className="section-title text-center">Latest health news</h2>
		  <div className="grid md:grid-cols-3 gap-4 flex flex-row flex-wrap justify-center mt-2">
		  	{news.map((el, i) =>
			  <div className="col-span-1 flex flex-col w-full h-64 bg-is-blue-20 p-4" key={el.name}>
				<h4>{el.name}</h4>
			</div>
			)}
		  </div>
	  </div>
}*/


const HomepageRich = ({publicView=false, about=false}) => {

	const user = useUser()

	const referralExperiment = useExperiment('bdJUWrcfTAy5XPRU5fAQtA')
	
	if (app.settings.is_ionic && !app.state.loaded) {
			return <Loader active />
	}

	const user_in = user.user_in

	return <div className={['home-iscr',about?'about':''].join(' ')}>
		{!__IONIC__ && <Hero user_in={user_in && !publicView} about={about}/>}
		{(app.site_status?.show_navigator || app.user?.claims?.admin || app.user?.claims?.supp || app.user?.claims?.mark) && <QuizHomeBanner/> }
		{!about && <CTA user_in={user_in && !publicView}/>}
		
		

	<div className={cls("home-section-extras", user_in&&"user")}>

	  <ImageTextBanner/>

	  <FeaturesTiles/>

	  <HIW/>

	  {/*<News/>*/}

	  <FAQ/>

	  <Partners/>

	  {about && user_in && <CTA  user_in={user_in}/>}
		{/*referralExperiment!=1 && user_in &&  <UserReferral fancy />*/}
  	</div>
	  
	</div>
};

export default HomepageRich;
